/* import __COLOCATED_TEMPLATE__ from './sq-tooltip.hbs.js'; */
var _dec, _dec2, _class;
import { classNames, tagName } from '@ember-decorators/component';
/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import Component from '@ember/component';
import $ from 'jquery';
import ActiveClassSupport from '@dashboard/junk-drawer/mixins/active-class-support'; // eslint-disable-line ember/no-mixins
import PopupSupport from '@dashboard/junk-drawer/mixins/popup-support'; // eslint-disable-line ember/no-mixins

/**
The tooltip component renders "i" element (trigger) and a nested popover component.
When the trigger is clicked, the popover will be set to active and will be visible.
When popover is active any click will close it.
TODO: (djs) The popover needs to be vertically positioned due to copy length

```example
@title Example

@hbs
{{#sq-tooltip class="icon-info l-invoice-tax-icon action"
              popoverClasses="l-invoice-popover l-invoice-popover--tax-info"}}
  peek a boo
{{/sq-tooltip}}
```
*/
let SqTooltip = (_dec = classNames('tooltip'), _dec2 = tagName('i'), _dec(_class = _dec2(_class = class SqTooltip extends Component.extend(ActiveClassSupport, PopupSupport) {
  click() {
    this.toggleProperty('isActive');
  }
  applicationClick(e) {
    // eslint-disable-next-line ember/no-jquery
    if (!this.isActive || !$(this.element)) {
      return undefined;
    }
    const inPopover = $(this.element).find(e.target).length; // eslint-disable-line ember/no-jquery
    const inTrigger = $(this.element).attr('id') === $(e.target).attr('id'); // eslint-disable-line ember/no-jquery
    if (inPopover || inTrigger) {
      return undefined;
    }
    this.set('isActive', false);
    return true;
  }
}) || _class) || _class);
export { SqTooltip as default };